import { Icon } from '@plone/volto/components';
import sortSVG from '../../../../../../volto-list-component/src/icons/sort.svg';
import { FC } from 'react';
import { HeaderComponentProps } from '../List';

const TableHeaderTitle: FC<Required<HeaderComponentProps>> = ({
  headerColor,
  columnData,
  title,
  count,
}) => (
  <>
    <div style={{ display: 'inline-block ' }}>
      <span style={{ backgroundColor: headerColor }} className="table-title">
        {title}
      </span>
      <span className="wrapper">
        {count} {columnData.label}
        {columnData.sortable ? (
          <Icon className="sort-icon" size="0.8em" name={sortSVG} />
        ) : null}
      </span>
    </div>
  </>
);

export default TableHeaderTitle;
